/**
 * Reformatage des prix pour afficher "27,25 €" au lieu de "€27,25 EUR"
 */
(function() {
  'use strict';
  
  // Protection contre les boucles infinies
  let isFormatting = false;
  let formatTimeout = null;

  function formatPriceText(text) {
    // Supprimer les textes d'accessibilité
    text = text.replace(/Prix habituel/gi, '');
    text = text.replace(/Prix promotionnel/gi, '');
    text = text.replace(/Regular price/gi, '');
    text = text.replace(/Sale price/gi, '');
    text = text.replace(/Prix soldé/gi, '');
    text = text.replace(/Prix réduit/gi, '');
    
    // Supprimer EUR
    text = text.replace(/\s*EUR\s*/g, '');

    // Transformer "$27.25" en "27,25 €" (format dollar → euro)
    text = text.replace(/\$\s*([0-9]+)\.([0-9]{2})/g, '$1,$2 €');
    text = text.replace(/\$\s*([0-9]+)/g, '$1 €');

    // Transformer "€27,25" en "27,25 €"
    text = text.replace(/€\s*([0-9]+(?:[,.][0-9]+)?)/g, '$1 €');
    
    // Transformer "From €27,25" en "À partir de 27,25 €"
    text = text.replace(/From\s+([0-9]+(?:[,.][0-9]+)?)\s*€/gi, 'À partir de $1 €');
    
    // Gérer les doublons de prix (ex: "14,95 € 14,95 €")
    // Extraire tous les prix
    const pricePattern = /([0-9]+(?:[,.][0-9]+)?)\s*€/g;
    const prices = [];
    let match;
    while ((match = pricePattern.exec(text)) !== null) {
      prices.push(match[1] + ' €');
    }
    
    // Si on a des doublons identiques, ne garder qu'un seul
    if (prices.length > 1) {
      const uniquePrices = [...new Set(prices)];
      if (uniquePrices.length === 1) {
        text = uniquePrices[0];
      } else if (uniquePrices.length === 2) {
        // Si 2 prix différents, c'est probablement un prix barré et un prix soldé
        text = uniquePrices.join(' ');
      }
    }
    
    // Nettoyer les espaces multiples
    text = text.replace(/\s+/g, ' ').trim();
    
    return text;
  }
  
  function formatPrices() {
    // Protection anti-boucle
    if (isFormatting) return;
    isFormatting = true;

    try {
      // Sélectionner tous les éléments contenant des prix
      const priceSelectors = [
      '.price-item',
      '.price__sale .price-item', 
      '.price__regular .price-item',
      '.product__info .price',
      '.card__information .price',
      '.price',
      '.product-price',
      'span[class*="price"]',
      '[data-price]'
    ];
    
    const priceElements = document.querySelectorAll(priceSelectors.join(', '));
    
    priceElements.forEach(element => {
      // Traiter directement le textContent de l'élément
      let text = element.textContent;
      if (text && (text.includes('€') || text.includes('EUR') || text.includes('$'))) {
        let formatted = formatPriceText(text);
        if (formatted !== text) {
          element.textContent = formatted;
        }
      }
    });
    
      // Reformater aussi les prix dans les boutons projet
      const projectButtons = document.querySelectorAll('.add-to-project-btn');
      projectButtons.forEach(button => {
        let priceAttr = button.getAttribute('data-product-price');
        if (priceAttr && (priceAttr.includes('EUR') || priceAttr.includes('€') || priceAttr.includes('$'))) {
          let formatted = formatPriceText(priceAttr);
          button.setAttribute('data-product-price', formatted);
        }
      });
    } finally {
      // Toujours réinitialiser le flag
      isFormatting = false;
    }
  }
  
  // Exécuter au chargement de la page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatPrices);
  } else {
    formatPrices();
  }
  
  // Ré-exécuter après les mises à jour AJAX (changement de variante, ajout au panier, etc.)
  if (window.Shopify && window.Shopify.theme) {
    document.addEventListener('variant:changed', formatPrices);
  }
  
  // Observer les changements du DOM pour les contenus chargés dynamiquement
  const observer = new MutationObserver(function(mutations) {
    // Éviter les appels multiples
    if (formatTimeout) {
      clearTimeout(formatTimeout);
    }

    // Vérifier si les mutations contiennent des éléments prix
    let hasPriceElements = false;

    for (let mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (let node of mutation.addedNodes) {
          if (node.nodeType === 1) { // Element node
            // Vérifier si c'est un élément prix ou contient des prix
            if ((node.classList && (node.classList.contains('price') ||
                                  node.classList.contains('money') ||
                                  node.classList.contains('price-item'))) ||
                (node.querySelector && node.querySelector('.price, .money, .price-item, [class*="price"]'))) {
              hasPriceElements = true;
              break;
            }
          }
        }
      }
      if (hasPriceElements) break;
    }

    // Formater seulement si nécessaire avec debounce
    if (hasPriceElements && !isFormatting) {
      formatTimeout = setTimeout(formatPrices, 200);
    }
  });
  
  // Observer seulement le main content, pas tout le body
  const mainContent = document.querySelector('main') || document.body;
  observer.observe(mainContent, {
    childList: true,
    subtree: true
  });
  
})();